import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalHeader from 'components/base/secure/modals/modal-header';
import SaveButton from 'components/form/save-button';
import InputField from 'components/form/input-field';
import { withNamespaces } from 'react-i18next';
import { inject } from 'mobx-react';
import ModalContent from 'components/base/secure/modals/modal-content';

@withNamespaces()
@inject('store')
class AddMemberModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            email: '',
        };

        this.dismiss = this.dismiss.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    onSubmit(e) {
        e.preventDefault();

        if (!this.state.loading) {
            this.setState({loading: true});

            this.props.store.family.requestAddMember({
                email: this.state.email,
            })
                .then(() => this.props.close())
                .catch(err => this.setState({loading: false})) // TODO: Add error
            ;
        }
    }

    dismiss() {
        this.props.dismiss();
    }

    handleChange(e) {
        const { name, value } = e.target;

        this.setState({
            [name]: value,
        });
    }

    render() {
        const { t } = this.props;
        const { loading, email } = this.state;

        return (
            <ModalContent>
                <ModalHeader
                    title={t('FAMILY.MANAGE.ADD_MEMBER.MODAL_TITLE')}
                    close={this.dismiss}
                />
                <div className="modal-body">
                    <form onSubmit={this.onSubmit}>
                        <InputField
                            name="email"
                            label={t('USER.EMAIL')}
                            onChange={this.handleChange}
                            value={email}
                            required={true}
                        />

                        <SaveButton loading={loading} />
                    </form>
                </div>
            </ModalContent>
        );
    }
}

AddMemberModal.propTypes = {
    close: PropTypes.func.isRequired,
    dismiss: PropTypes.func.isRequired,
};

export default AddMemberModal;


// WEBPACK FOOTER //
// ./src/modules/family/components/add-member/add-member-modal.js